import Link from "next/link";
import styles from "./category-tile.module.css";
import { useRouter } from "next/navigation";
export default function Category(props: {
  imageUrl: string;
  header: string;
  text: string;
  route: string;
}) {
  const router = useRouter();
  return (
    <div
      onClick={() => router.push(props.route)}
      className={styles.categoryWrapper}
      style={{ backgroundImage: `url(${props.imageUrl})` }}
    >
      <div>
        <h3>{props.header}</h3>
        <span>{props.text}</span>
      </div>
    </div>
  );
}
